
import { Component, OnInit, Output, EventEmitter,ViewChild  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Dep } from '../class/auth';
import { page }  from '../class/status';
import { menulist }  from '../class/status';
import { ToastComponent } from "../../layout/toast/toast.component";
import Swal from 'sweetalert2';

@Component({
  selector: 'app-user-permission',
  templateUrl: './user-permission.component.html',
  styleUrls: ['./user-permission.component.css']
})

export class UserPermissionComponent implements OnInit {
    @ViewChild(ToastComponent, { static: true }) toastComponent: ToastComponent;
    constructor(
        public httpClient: HttpClient,
    ){}

    ngOnInit(): void {
        this.init_list();
    }

    loading:boolean=true;
    data:any=[];
    sort_obj:any = {column:'create_dt',sort:'0'}
    pageobj:page = {page:0,count:10,total_count:0};
    pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj));
    isUpdating: { [key: string]: boolean } = {}; // 追蹤每個按鈕的載入狀態

    tcontent:any = [
        {title:'名稱',content:'name',type:2},
        {title:'直播/語聊',content:'live',type:3},
        {title:'截圖/錄影',content:'capture_media',type:3},
        {title:'玩具',content:'toy',type:3},
        {title:'建立時間',content:'create_dt'},
        {title:'更新時間',content:'update_dt'},
    ];

    live_type = '-2';

    live_list:menulist = [
        {id:'-1',name:'全部'},
        {id:'0',name:'停用'},
        {id:'1',name:'啟用'},
    ];

    capture_media_type = '-2';

    capture_media_list:menulist = [
        {id:'-1',name:'全部'},
        {id:'0',name:'停用'},
        {id:'1',name:'啟用'},
    ];

    toy_type = '-2';

    toy_list:menulist = [
        {id:'-1',name:'全部'},
        {id:'0',name:'停用'},
        {id:'1',name:'啟用'},
    ];

    search_name = '';

    // 自動切換狀態（點擊就切換）
    autoToggle(type: 'live' | 'capture_media' | 'toy', item: any): void {

        // 取得當前狀態並計算新狀態
        const currentStatus = item[type];
        const newStatus = currentStatus === '1' ? '0' : '1';

        const titleMap: { [key: string]: string } = {
            live: '直播/語聊',
            capture_media: '截圖/錄影',
            toy: '玩具',
        };
        const titile = titleMap[type];

        Swal.fire({
            title: "確定要修改" + titile + "的狀態嗎?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "確定",
            cancelButtonText: "取消"
        }).then((result) => {
            if (result.isConfirmed) {
                const body = { data: item, newStatus: newStatus ,type:type };
                this.httpClient.post<any>("/setting/set_userpermission.php", body).subscribe(res => {
                    this.loading = false;
                    Swal.fire({
                        title: "已修改!",
                        icon: "success"
                    });
                    this.init_list(); // 成功後也呼叫
                }, error => {
                    this.loading = false;
                    this.init_list(); // 錯誤後也呼叫
                });
            } else {
                this.init_list(); // 取消時呼叫
            }
        });
    }


    callback(pageobj:page){
        if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
            this.pageobj = pageobj;
            this.init_list();
        }
    }

    init_list(){
        this.loading = true;
        const body = {
            page: this.pageobj.page,
            count: this.pageobj.count,
            sort_obj: this.sort_obj,
            live_type:this.live_type,
            search_name:this.search_name,
            capture_media_type:this.capture_media_type,
            toy_type:this.toy_type,
        };
        this.httpClient.post<any>("/setting/get_userpermission.php",body).subscribe(res => {
            this.loading = false;
            console.log('load',res);
            if(res.status){
                this.data = res.data;
                this.pageobj.total_count = res.total_count;
                this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj));
            }else{
                this.data = [];
            }

        });
    }

    default_page(){
        this.pageobj = {page:0,count:10,total_count:0};
        this.init_list();
    }


    handlesortdata( value: any ): void {
        this.sort_obj = value;
        this.init_list();
    }

}
